import React from "react";
import styled from "styled-components";

import {
  Box,
  LazyImage,
  SpanStyled,
  TextStyled,
} from "../../../styled/Elements";
import { MenuTriggerCross, PlaceholderImg } from "../../../styled/AllImages";

const SelectedUserList = ({ selectedMainParents, onRemoveClick }) => {
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  return selectedMainParents.map((mainParent) => (
    <UserUpload key={mainParent?.id}>
      <Box className="userPlaceholder">
        <LazyImage
          src={
            mainParent?.profile
              ? `${ASSET_URL}/${mainParent?.profile}`
              : PlaceholderImg
          }
          alt="User"
        />
      </Box>
      <Box className="userDataNameRole">
        <TextStyled>
          <SpanStyled
            color="var(--text)"
            size="16px"
            weight="bold"
            className=""
          >
            {mainParent?.name}
          </SpanStyled>
        </TextStyled>
        {mainParent?.subLabel && (
          <SpanStyled
            color="var(--text2)"
            size="14px"
            className=""
          >
            {mainParent?.subLabel}
          </SpanStyled>
        )}
      </Box>

      <MenuTriggerCross
        className="removeTaskTrigger"
        onClick={() => onRemoveClick(mainParent?.id)}
      />
    </UserUpload>
  ));
};

export default SelectedUserList;

const UserUpload = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  padding: 8px 16px;
  background-color: var(--bgSecondary);
  border-radius: 10px;
  .userPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    background-color: var(--greyBg);
    border-radius: 50%;
    // border: 1px dashed var(--greyText);
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  svg.removeTaskTrigger {
    width: 12px;
    height: 12px;
    margin-left: 7px;
    &:hover {
      stroke: var(--redColor);
      fill: var(--redColor);
      path {
        stroke: var(--redColor);
        fill: var(--redColor);
      }
    }
  }
  input[type="file"] {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .abtUser {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    span {
      // width: 100%;
    }
  }
`;
/*
const UserUpload = styled.div`
  // display: flex;
  // gap: 15px;
  // align-items: center;
  // overflow: hidden;
  // position: relative;
  // cursor: pointer;
  .UserUploadBtn {
	display: flex;
	gap: 15px;
	align-items: center;
  }
  .userPlaceholder {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background-color: var(--greyBg);
	border-radius: 50%;
	border: 1px dashed var(--greyText);
	overflow: hidden;
	img {
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	}
  }
  .selected.dropdown-item {
	background-color: var(--greyBg);
  }
`;
*/
